import ConsoleApi from "apps/console/enums/consoleApi";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";
import { ApiEventSeries } from "shared/types/ApiEventSeries";

export function getEventSeriesListKey(clientId: string, userId = "", isPlatformUser?: boolean) {
  return getApiQueryKey(
    getApiForEventSeries(clientId, isPlatformUser),
    getParamsForEventSeries(clientId, userId, isPlatformUser)
  );
}

function getApiForEventSeries(clientId: string, isPlatformUser?: boolean) {
  if (clientId && isPlatformUser) {
    return ConsoleApi.GET_EVENT_SERIES_DETAILS_LIST;
  } else {
    return ConsoleApi.GET_EVENT_SERIES_DETAILS_LIST_BY_USER;
  }
}

function getParamsForEventSeries(clientId: string, userId: string, isPlatformUser?: boolean) {
  if (clientId && isPlatformUser) {
    return { params: { clientId } };
  } else {
    return { params: { consoleUserId: userId } };
  }
}

export function useGetEventSeriesDetailsList(clientId: string, userId = "", isPlatformUser?: boolean) {
  return useGetApiData<Array<ApiEventSeries>>(
    getApiForEventSeries(clientId, isPlatformUser),
    getParamsForEventSeries(clientId, userId, isPlatformUser),
    {
      enabled: Boolean(clientId) || Boolean(userId)
    }
  );
}
